import React from 'react';
/** Personal Components */
import QuestionFillinchinese from './fillinchinese';
import QuestionFillin from './fillin';
import QuestionSelect from './select';
import QuestionJudge from './judge';
import QuestionHollow from './hollow';
/** Personal Js */
import * as Types from '../../../../../utils/questionType';

const Question = (props) => {
    let obj = props.data;

    return (
        <div>
            {/** 中文填空题 */}
            {
                obj.type == Types.TYPE_SHOW_FILLIN_CHINESE &&
                <QuestionFillinchinese {...props} obj={obj} />
            }
            {/** 填空题 */}
            {
                obj.type == Types.TYPE_SHOW_FILLIN &&
                <QuestionFillin {...props} obj={obj} />
            }
            {/** 选择题 */}
            {
                obj.type == Types.TYPE_SHOW_SELECT &&
                <QuestionSelect {...props} obj={obj} />
            }
            {/** 多选题 */}
            {
                obj.type == Types.TYPE_SHOW_MULTISELECT &&
                <QuestionSelect {...props} obj={obj} />
            }
            {/** 判断题 */}
            {
                obj.type == Types.TYPE_SHOW_JUDGE &&
                <QuestionJudge {...props} obj={obj} />
            }
            {/** 图片挖空题 */}
            {
                obj.type == Types.TYPE_SHOW_HOLLOW &&
                <QuestionHollow {...props} obj={obj} />
            }
        </div>
    )
};

export default Question;


// WEBPACK FOOTER //
// ./src/entry_question_editor/question/exercise/step/sub-question/view.js